import React, { FC } from "react";
import { FolderWrapper } from "../FolderWrapper";
import { SECTION_IDS } from "../constants";
import { Slider } from "./Slider";

export const TeamSection: FC = () => (
  <FolderWrapper
    title="Команда"
    titleClassName="text-white-base bg-green-base"
    id={SECTION_IDS.TEAM}
    className="bg-green-base flex flex-col gap-6 md:gap-16 pt-11 pb-6 2xl:py-21.5"
  >
    <p className="text-white-base text-10 md:text-base px-5 md:px-10 xl:px-31">
      Команда нашої компанії – це висококваліфіковані спеціалісти, які мають
      багаторічний досвід у сфері бухгалтерії, управління проєктами та кадрового
      діловодства. Ми об'єднуємо людей, які не тільки глибоко розуміються на
      своїй справі, але й поділяють спільні цінності: професіоналізм,
      відповідальність і партнерство. Кожен член команди постійно вдосконалює
      свої знання, працюючи з клієнтами на засадах довіри та співпраці. Разом ми
      надаємо послуги найвищої якості, допомагаючи нашим клієнтам досягати нових
      висот у бізнесі.
    </p>

    <Slider />
  </FolderWrapper>
);
